import React from 'react';

const MapContainer = (props) => {
  const { formalName, googlePlaceId } = props;
  let placeId = 'ChIJBwU-Qjf9EogRjnwai8-yzI4'; // General Purdue Place ID as fallback.
  if (googlePlaceId) {
    placeId = googlePlaceId;
  }
  return <iframe
    title={formalName}
    src={"https://www.google.com/maps/embed/v1/place?q=place_id:" + placeId + "&attribution_source=Purdue+Dining+Menus+Online&key=AIzaSyCeYyABTpJKRz0DE8Vyitj3ZUPI4w8Aw7c"}
    style={{ height: 280, width: "100%", border: 0 }}
    loading="lazy"
    allowFullScreen
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>;
}

export default MapContainer;